import { lazy } from 'react';
import Loader from './Loader/Loader';

// Lazy load heavy components to improve initial bundle size
export const LazyQuoteForm = lazy(() => import('./QuoteForm/QuoteForm'));
export const LazyAuthModal = lazy(() => import('./Auth/AuthModal'));
export const LazyRequestModal = lazy(() => import('./RequestModal'));
export const LazyScanner = lazy(() => import('./Scanner/Scanner'));

// Dashboard components (if they exist)
export const LazyDashboard = lazy(() => 
  import('../Dashboard/Users/Components/QuotationPage').catch(() => 
    import('./NotFound') // Fallback if component doesn't exist
  )
);

// Loading component for Suspense fallback
export const LoadingSpinner = () => (
  <Loader/>
);